import {defineStore} from 'pinia';

import {ModuleBudgetSourceProperty} from '../moduleConst';

import {BaseDictionaryStore} from '../baseDictionaryStore';

import budgetSourcePropertyAPI from '@/apis/di/budgetSourcePropertyAPI';

const budgetSourcePropertyStore = new BaseDictionaryStore(budgetSourcePropertyAPI);

export const useBudgetSourcePropertyStore = defineStore(ModuleBudgetSourceProperty, {
  state: () => ({
    ...budgetSourcePropertyStore.state,
    _config: {
      key: 'budget_source_property_id',
      code: 'budget_source_property_code',
      name: 'budget_source_property_name',
      table: 'di_budget_source_property',
      moduleName: 'Tính chất nguồn kinh phí',
      defaultSort: 'budget_source_property_code',
    },
    moduleName: 'budgetSourceProperty',
  }),
  actions: {...budgetSourcePropertyStore.action},
  getters: {
    ...budgetSourcePropertyStore.getters,
  },
});
